import React from 'react';
import { ThemeToggle } from './ThemeToggle';

export const Header: React.FC = () => {

  const handleHomeClick = () => {
    // Reload the page to go back to home screen
    window.location.reload();
  };

  return (
    <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
      <div className="container mx-auto px-4 py-6 max-w-7xl">
        <div className="flex items-center justify-between">
          <div 
            className="flex items-center space-x-3 cursor-pointer group"
            onClick={handleHomeClick}
          >
            <div className="flex items-center">
              <img 
                src="/assets/weatherlogo.png" 
                alt="Perfect Weather Logo" 
                className="h-20 w-20 object-contain group-hover:scale-105 transition-transform duration-200"
              />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-200">
                Perfect Weather
              </h1>
              <p className="text-sm text-gray-600 dark:text-gray-400 group-hover:text-gray-800 dark:group-hover:text-gray-200 transition-colors duration-200">
                Weather-informed decisions for life
              </p>
            </div>
          </div>
          
          <div className="flex items-center">
            <ThemeToggle />
          </div>
        </div>
      </div>
    </header>
  );
};
